import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const PrimaryIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M16.1706 8.73593C16.5871 9.09861 16.6307 9.73027 16.268 10.1468L12.1232 14.9067C11.9444 15.112 11.6896 15.2356 11.4177 15.2488C11.1457 15.2621 10.8801 15.1638 10.6822 14.9768L8.30126 12.7268C7.89986 12.3475 7.88195 11.7146 8.26128 11.3132C8.64061 10.9118 9.27352 10.8939 9.67493 11.2732L11.2989 12.8078L14.7597 8.83338C15.1224 8.41688 15.7541 8.37324 16.1706 8.73593Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.7408 2.44077C11.4754 1.84532 12.5267 1.8458 13.2608 2.44192L15.2789 4.0806L17.8542 4.3499C18.7912 4.44787 19.5327 5.18643 19.6345 6.123L19.9161 8.71405L21.5537 10.7477C22.1437 11.4804 22.1433 12.5252 21.5528 13.2575L19.9226 15.2792L19.6496 17.8707C19.5507 18.809 18.8096 19.5505 17.8715 19.65L15.2843 19.9244L13.2534 21.5568C12.5213 22.1453 11.4782 22.1449 10.7464 21.5559L8.71818 19.9235L6.13363 19.6425C5.2003 19.541 4.46316 18.804 4.36152 17.8707L4.07955 15.2815L2.45853 13.2361C1.88019 12.5064 1.88196 11.4741 2.4628 10.7463L4.07426 8.72722L4.35631 6.13156C4.45786 5.19705 5.19649 4.45938 6.13113 4.35904L8.71646 4.0815L10.7408 2.44077ZM12.0001 3.99451L9.97578 5.63524C9.67635 5.87793 9.31317 6.02893 8.92994 6.07007L6.34461 6.34761L6.06255 8.94327C6.02156 9.32048 5.87412 9.67825 5.63743 9.97481L4.02597 11.9939L5.64699 14.0393C5.88111 14.3347 6.02698 14.6903 6.06779 15.065L6.34977 17.6542L8.93432 17.9352C9.31428 17.9765 9.67446 18.1258 9.9722 18.3654L12.0004 19.9979L14.0313 18.3655C14.3302 18.1252 14.692 17.976 15.0734 17.9355L17.6606 17.6612L17.9336 15.0696C17.9739 14.6867 18.1239 14.3235 18.3657 14.0237L19.9959 12.0021L18.3583 9.96842C18.1185 9.67059 17.9691 9.31025 17.9278 8.93011L17.6462 6.33905L15.0709 6.06976C14.685 6.02942 14.3193 5.87773 14.0181 5.63319L12.0001 3.99451Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

PrimaryIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(PrimaryIcon);
